import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { copyFor } from '../../copy/copy';

const LegalInfoContainer = styled.div`
    display: ${props => (props.align === 'right' ? 'inline !important' : 'flex')};

    @media (max-width: 30em) {
        display: ${props =>
            props.align === 'mobile-right' ? 'inline !important' : 'flex'};
    }
`;

const Span = styled.div`
    font-size: 8px;
    font-family: Averta;
    float: ${props => (props.align === 'right' ? 'right' : 'none')};
    width: ${props => (props.align === 'right' ? '150px' : 'auto')};

    @media (max-width: 30em) {
        float: ${props => (props.align === 'mobile-right' ? 'right' : 'none')};
        width: ${props => (props.align === 'mobile-right' ? '150px' : 'auto')};
    }

    a {
        color: #008eff;
        text-decoration: none;
    }
`;

const termsText = () =>
    copyFor('miscellaneous', 'legalInfo', undefined, undefined, {
        termsLink:
            '<a href="https://actionbutton.org/terms" target="_blank" rel="noopener noreferrer">',
        endTermsLink: '</a>',
        privacyPolicyLink:
            '<a href="https://actionbutton.org/privacy" target="_blank" rel="noopener noreferrer">',
        endPrivacyPolicyLink: '</a>'
    });

const LegalInfo = props => (
    <LegalInfoContainer align={props.align}>
        <Span
            align={props.align}
            dangerouslySetInnerHTML={{
                __html: termsText()
            }}
        />
    </LegalInfoContainer>
);

LegalInfo.propTypes = {
    align: PropTypes.string
};

export default connect(state => {
    return {
        partnerId: state.widget.activeAction.partner
            ? state.widget.activeAction.partner.id
            : null
    };
})(LegalInfo);
